import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { elkoConfig } from "./data";

export default function ElkoPage() {
  return <OregonCityPageTemplate config={elkoConfig} />;
}